import { useNavigate, useParams } from "react-router-dom";
import LayoutMain from "../../../shared/layouts/LayoutMain/LayoutMain";
import { FormBase } from "../../../shared/interface/form-base";
import { useForm } from "react-hook-form";
import SwitchFields from "../../../shared/components/Bc-SwitchFields/Bc-SwitchFields";
import { BCButton } from "../../../shared/styled/global.styled";
import UserInfoApi from '../../../auth/user-info-api';
import { useSaveService, useService } from "../../../hook/useServices";
import { useEffect, useState } from "react";
import BcFieldsBuilder from '../../../shared/components/Bc-FieldsBuilder/Bc-FieldsBuilder';
import { Action } from "../../../shared/enums/action.enums";
import BcModal from "../../../shared/components/Bc-Modal/Bc-Modal";
import { Api } from "../../../core/services/api.services";

const principalForm: FormBase[] = [
    {
      item: "user",
      isRequired: true,
      type: "hidden",
    },
    {
      item: "name",
      label: "Nombre del formulario",
      placeholder: "Ejemplo: Formulario de creación de audiencia",
      isRequired: true,
      type: "text",
    },
    {
        item: "fields",
        isRequired: false,
        type: "hidden",
    },
    {
        item: "dateCreate",
        isRequired: false,
        type: "hidden",
    },
    {
        item: "dateEdit",
        isRequired: false,
        type: "hidden",
    },
    {
        item: "version",
        isRequired: false,
        type: "hidden",
    },
  ];

const getUser = async () => {
  const { email } = await UserInfoApi.getUserInfo();
  return email;
};

const saveForm = async (payload: any) => {
    const { data } = await Api.saveForm(payload);
    console.log( data);
    return  data;
}

const FormBuilder = () => {

  const userQuery = useService('users', getUser);
  const username = (userQuery.data as string);

  const formMutation = useSaveService(saveForm);

  const { id } = useParams();
  if (id) console.log(id);

  const navigate = useNavigate();

  const [openDiag, setOpenDiag] = useState<boolean>(false);

  const handleModal = () => {
    setOpenDiag(!openDiag);
  };

  const {
    register,
    unregister,
    setValue,
    handleSubmit,
    getValues,
    watch,
    resetField,
    formState: { isValid },
  } = useForm<any>({ mode: "onChange" });
  const onSubmit = handleSubmit((data) => {
    console.log(data);
    formMutation.mutate(data);
  });

  const dataFields = getValues('fields');

  useEffect(() => {
    setValue('user', username, { shouldValidate: true });
    setValue('dateCreate', new Date().toDateString(), { shouldValidate: true });
    setValue('fields', getValues('fields'), { shouldValidate: true });
    setValue('dateEdit', new Date().toDateString(), { shouldValidate: true });
    setValue('version', 1, { shouldValidate: true });
  }, [dataFields, username, setValue, getValues])

  return (
    <LayoutMain idPage={id ? `Editar formulario${id}` : "Crear formularios"} titlePage={true}>
      <div className="bc-container">
        <form>
          {principalForm.map((field: FormBase) => (
              <SwitchFields
                key={`master${field.item}`}
                field={field}
                register={register}
                unregister={unregister}
                setValue={setValue}
                isRequired={field.isRequired}
                getValues={getValues}
                watch={watch}
                resetField={resetField}
              />
            ))}
        </form>
        <BcFieldsBuilder action={Action.CREATE} fieldPather={'fields'} setValuePather={setValue} getValuesPather={getValues} />
        <BCButton
            type="button"
            className="bc-button-primary bc-button-small"
            disabled={!isValid}
            onClick={handleModal}
          >
            {id ? "Editar" : "Crear"}
          </BCButton>
      </div>
      <BcModal
        openModal={openDiag}
        type="info"
        title="Crear formulario"
        onClose={handleModal}
      >
        <section className="bc-modal-content">
          <div className="text-center bc-mb-2 bc-mt-2">
            <p>
              Estas a punto de crear un formulario dinamico, 
            </p>
            <p><strong>¿Deseas continuar?</strong></p>
          </div>
        </section>
        <section className="bc-modal-button-container">
          <BCButton type="button" className="bc-button-primary bc-button-small" tabIndex={0} onClick={onSubmit}>
            Continuar
          </BCButton>
          <BCButton
            type="button"
            className="bc-button-secondary bc-button-small"
            tabIndex={1}
            onClick={handleModal}
          >
            Cancelar
          </BCButton>
        </section>
      </BcModal>
      <BcModal
        openModal={formMutation.isSuccess}
        type="success"
        title="Creación exitosa"
        onClose={handleModal}
      >
        <section className="bc-modal-content">
          <div className="text-center bc-mb-2 bc-mt-2">
            <p>
              Formulario con nombre {formMutation.data?.name} y id {formMutation.data?.id} fue creado con exito.
            </p>
          </div>
        </section>
        <section className="bc-modal-button-container">
          <BCButton type="button" className="bc-button-primary bc-button-small" tabIndex={0} onClick={() => navigate('/formularios')}>
            Aceptar
          </BCButton>
        </section>
      </BcModal>
      <BcModal
        openModal={formMutation.isError}
        type="error"
        title="Error "
        onClose={handleModal}
      >
        <section className="bc-modal-content">
          <div className="text-center bc-mb-2 bc-mt-2">
            <p>
              {JSON.stringify(formMutation.error)}
            </p>
          </div>
        </section>
        <section className="bc-modal-button-container">
          <BCButton type="button" className="bc-button-primary bc-button-small" tabIndex={0} onClick={() => navigate('/formularios')}>
            Aceptar
          </BCButton>
        </section>
      </BcModal>
    </LayoutMain>
  );
};

export default FormBuilder;
